import React from 'react';
import PropTypes from 'prop-types';

import './_booksMapping.scss';

export const TargetInstancesTable = ({ instances }) => {
  return (
  <table className="target-instances-table">
      <thead>
        <tr>
          <th className="target-instances-source">Source</th>
          <th className="target-instances-property-id">Property ID</th>
        </tr>
      </thead>
      <tbody>
        {instances.map((instance, idx) => (
          <tr key={instance.source}>
            <td className="target-instances-source">{instance.source}</td>
            <td className="target-instances-property-id">{instance.property_id}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

TargetInstancesTable.propTypes = {
  instances: PropTypes.array,
};
